import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { RefreshProvider } from "./context/RefreshContext";
import { SophieProvider } from "./context/SophieContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import CalendarPage from "./pages/CalendarPage";
import Bookings from "./pages/Bookings";
import Customers from "./pages/Customers";
import Stylists from "./pages/Stylists";
import Services from "./pages/Services";
import Settings from "./pages/Settings";
import Analytics from "./pages/Analytics";
import PublicBookingPage from "./pages/PublicBookingPage";
import WidgetPage from "./pages/WidgetPage";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <AuthProvider>
      <RefreshProvider>
        <SophieProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/login" element={<Login />} />
              {/* Public booking page — no auth required */}
              <Route path="/book/:token" element={<PublicBookingPage />} />
              {/* Sophie website widget — no auth required, served in iframe */}
              <Route path="/widget/:token" element={<WidgetPage />} />
              <Route
                element={
                  <ProtectedRoute>
                    <Layout />
                  </ProtectedRoute>
                }
              >
                <Route path="/" element={<Dashboard />} />
                <Route path="/calendar" element={<CalendarPage />} />
                <Route path="/bookings" element={<Bookings />} />
                <Route path="/customers" element={<Customers />} />
                <Route path="/stylists" element={<Stylists />} />
                <Route path="/services" element={<Services />} />
                <Route path="/analytics" element={<Analytics />} />
                <Route
                  path="/settings"
                  element={
                    <ProtectedRoute roles={["admin", "staff"]}>
                      <Settings />
                    </ProtectedRoute>
                  }
                />
              </Route>
            </Routes>
          </BrowserRouter>
          <Toaster richColors position="top-right" />
        </SophieProvider>
      </RefreshProvider>
    </AuthProvider>
  );
}

export default App;
